import type { Translation } from '../types.ts';
import type en from '../en/shipping.ts';

export default {
    index: {
        title: 'Verzending',
        intro: 'Vervoerders, tarieven en bestemmingszones voor {website}.',
        noWebsite: 'Kies eerst een website om de verzending ervan te beheren.',
    },
    tabs: {
        carriers: 'Vervoerders en tarieven',
        zones: 'Bestemmingszones',
    },
    kinds: {
        ship: 'Verzenden naar klant',
        pickup: 'Afhalen',
    },
    sizes: {
        any: 'Elk formaat',
        letterbox: 'Brievenbuspakje',
        small: 'Klein pakket',
        large: 'Groot pakket',
    },
    shared: {
        enabled: 'Ingeschakeld',
        kind: 'Soort',
        sortOrder: 'Volgorde',
    },
    carriers: {
        intro: 'Vervoerders waaruit klanten bij het afrekenen kiezen. Bij afhalen is geen verzendadres nodig.',
        new: 'Nieuwe vervoerder',
        empty: 'Nog geen vervoerders. Voeg een vervoerder of een afhaaloptie toe.',
        deliversTo: 'Levert in',
        rates: 'geen tarieven | {n} tarief | {n} tarieven',
        noZones: 'Geen zones: deze vervoerder wordt nooit aangeboden',
        confirmDelete: 'Vervoerder "{name}" verwijderen? De tarieven ervan worden ook verwijderd.',
        created: 'Vervoerder aangemaakt',
        saved: 'Vervoerder opgeslagen',
        deleted: 'Vervoerder verwijderd',
    },
    carrierEdit: {
        newTitle: 'Nieuwe vervoerder',
        editTitle: 'Vervoerder bewerken',
        codeHint: 'Vaste slug, wordt op bestellingen vastgelegd.',
        kindLocked: 'De soort ligt vast na het aanmaken.',
        pickupPrice: 'Afhaalprijs (centen)',
        pickupPriceHint: 'Meestal 0 voor gratis afhalen.',
        pickupLocation: 'Afhaallocatie / instructies',
        pickupLocationPlaceholder: 'Hoofdstraat 1, open 9–17 uur',
        rateTable: 'Tarieventabel',
        rateTableHint: 'Eén regel per zone × formaat × gewichtsklasse; de goedkoopste passende regel wordt berekend. De zonekolom bepaalt ook waar deze vervoerder levert: in een zone zonder regel hier wordt hij nooit aangeboden. Meerdere vervoerders mogen dezelfde zone bedienen; de klant kiest er dan bij het afrekenen een op naam en prijs.',
        addRate: 'Tarief toevoegen',
        zonesFirst: 'Maak eerst een bestemmingszone aan (tabblad Bestemmingszones) voordat je tarieven toevoegt.',
        zone: 'Zone',
        service: 'Dienst',
        servicePlaceholder: 'Standaard',
        size: 'Formaat',
        minWeight: 'Min. g',
        maxWeight: 'Max. g',
        price: 'Prijs (centen)',
        freeOver: 'Gratis vanaf (centen)',
        daysMin: 'Min. dagen',
        daysMax: 'Max. dagen',
        sortOrderHint: 'Lager staat eerder in de lijst bij het afrekenen.',
        create: 'Vervoerder aanmaken',
        save: 'Vervoerder opslaan',
    },
    zones: {
        intro: 'Groepeer bestemmingslanden in zones. Een restzone dekt al het andere.',
        new: 'Nieuwe zone',
        empty: 'Nog geen zones. Voeg er minstens één toe om tarieven voor vervoerders in te stellen.',
        countries: 'Landen',
        restOfWorld: 'Rest van de wereld',
        confirmDelete: 'Zone "{name}" verwijderen? Tarieven voor deze zone worden ook verwijderd.',
        created: 'Zone aangemaakt',
        saved: 'Zone opgeslagen',
        deleted: 'Zone verwijderd',
    },
    zoneEdit: {
        newTitle: 'Nieuwe zone',
        editTitle: 'Zone bewerken',
        namePlaceholder: 'Binnenland / EU / Wereld',
        countries: 'Landcodes',
        countriesHint: 'ISO 3166-1 alpha-2, gescheiden door komma of spatie. Wordt genegeerd bij een restzone.',
        postcodes: 'Postcodes (optioneel)',
        postcodesHint: 'Eén regel per lijn: een reeks (6300-6399), een begin (62*), een cijferblok (6291) of één exacte postcode (6301 CV). Laat leeg om het hele land te dekken. Zo verkoopt een bedrijf dat zelf bezorgt alleen waar zijn bus komt.',
        catchAll: 'Restzone (rest van de wereld)',
        catchAllHint: 'Geldt voor elke bestemming die geen andere zone dekt.',
        create: 'Zone aanmaken',
        save: 'Zone opslaan',
    },
} satisfies Translation<typeof en>;
